export default __webpack_public_path__ + "static/media/SPINNER1B.b9e1118d.png";